import React from 'react';
import { motion } from 'framer-motion';
import './CSR.css';

const CSR: React.FC = () => {
  return (
    <div className="venture-page">
      <div className="venture-container">
        {/* Main Content */}
        <div className="venture-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="venture-main-section"
          >
            <div className="venture-header">
              <div className="venture-header-background"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/agriculture.jpg)` }}
              >
                <div className="venture-header-overlay">
                  <h2 className="section-main-title">CSR</h2>
                </div>
              </div>
            </div>
           

            <div className="venture-content-container">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="venture-text-section"
              >
                <div className="venture-text-content">
                  <div className="venture-text">
                    
                    <h2 className="project-title">Ansuvara Foundation</h2>
                    <p>
                      Philanthropy lies at the heart of Ansuvara Group, rooted in the core values and vision of our founder.
                      Through the Ansuvara Foundation, the Group carries forward its commitment to social responsibility by
                      supporting initiatives in education, healthcare, community development, and disaster relief. The
                      Foundation reflects our enduring belief that business success must go hand-in-hand with meaningful
                      service to society. Anchored in compassion and impact-driven action, Ansuvara Foundation continues to
                      work towards building stronger, more resilient communities across Gandaki.
                    </p>
                   

                    

                    <br/>
                    <br/>
                  </div>
                </div>
              </motion.div>
            </div>

          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CSR;

